"use client";

import Img from "@casino/legacyUi/Img";
import { cn } from "@workspace/frontend-ui";
import { useEffect, useState } from "react";
import type { BannerNavItem } from "..";
import ProgressBar from "./ProgressBar";

type Props = {
  item: BannerNavItem;
  isActive: boolean;
  isLast: boolean;
  delay: number;
  onSelect: () => void;
};

const BannerNavigationItem: FC<Props> = ({
  item,
  isActive,
  isLast,
  delay,
  onSelect,
}) => {
  const [showProgress, setShowProgress] = useState(false);

  useEffect(() => {
    setShowProgress(isActive);
  }, [isActive]);

  return (
    <div
      className="relative grid min-h-[102px] cursor-pointer grid-cols-[1fr_2fr] items-center gap-4 px-6"
      onClick={onSelect}
    >
      <Img
        src={item.imgSrc}
        width={144}
        height={60}
        alt=""
        className="h-[54px] w-[72px] rounded-md bg-foreground object-cover"
      />
      <div className="line-clamp-3 block max-h-16 break-words font-headline text-sm font-light">
        {item.name}
      </div>
      {(!isLast || isActive) && (
        <div
          className={cn(
            "absolute bottom-[0.5px] left-0 hidden h-[0.5px] w-full bg-border 3xl:block",
            isActive && "h-0.5",
          )}
        />
      )}
      {isActive && <ProgressBar isActive={showProgress} delay={delay} />}
      {!isLast && (
        <div className="absolute right-0 h-14 w-px bg-border 3xl:hidden" />
      )}
    </div>
  );
};

export default BannerNavigationItem;
